import { useState, useMemo } from 'react';
import { AdjustmentRequestList } from '../components/AdjustmentRequestList';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useEmployees } from '../hooks/useEmployees';
import { Select } from '@travellegacy/nexops-design-system';

const STATUS_OPTIONS = [
  { value: '', label: 'Todas' },
  { value: 'PENDING', label: 'Pendentes' },
  { value: 'APPROVED', label: 'Aprovadas' },
  { value: 'REJECTED', label: 'Rejeitadas' },
];

export default function AjustesPage() {
  const { user } = useAuth();
  const isGestor = user?.role === 'GESTOR' || user?.role === 'ADMIN';
  const [statusFilter, setStatusFilter] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');

  const { data: allEmployees = [] } = useEmployees();

  // Only show COLLABORATOR in the select
  const collaborators = useMemo(
    () => allEmployees.filter((e) => e.user?.role === 'COLLABORATOR'),
    [allEmployees]
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">
          {isGestor ? 'Solicitações de Ajuste' : 'Meus Ajustes de Ponto'}
        </h1>
        <p className="text-muted-foreground mt-1">
          {isGestor
            ? 'Revise e aprove as solicitações de ajuste dos colaboradores'
            : 'Acompanhe suas solicitações de ajuste de ponto'}
        </p>
      </div>

      {/* Filters row */}
      <div className="flex flex-wrap items-center gap-4">
        {/* Status filter */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-muted-foreground">Status:</span>
          <div className="flex gap-2">
            {STATUS_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                onClick={() => setStatusFilter(opt.value)}
                className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                  statusFilter === opt.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-accent hover:text-accent-foreground'
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Collaborator select — admin/gestor only */}
        {isGestor && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-muted-foreground">Colaborador:</span>
            <Select
              value={selectedEmployeeId}
              onChange={(e) => setSelectedEmployeeId(e.target.value)}
              options={[
                { value: '', label: 'Todos' },
                ...collaborators.map((emp) => ({
                  value: emp.id,
                  label: emp.user?.name ?? emp.id,
                })),
              ]}
              className="w-48"
            />
          </div>
        )}
      </div>

      <AdjustmentRequestList
        isGestor={isGestor}
        employeeId={selectedEmployeeId || undefined}
        statusFilter={statusFilter || undefined}
      />
    </div>
  );
}
